import { LOCATION_CHANGE } from '../../libs/router/redux-store';
import _ from 'lodash';
import { TAction } from '../actions/types/action';
import {
  ADD_PENDING_ROLE_PARAMS,
  RELOAD,
  SET_BLOCK_LIST,
  SET_CHARACTER_CUSTOMIZATION_PARAMS,
  SET_CHARACTER_PRIVACY_PARAMS,
  SET_GROUP_CLIENT_USAGE_DATA,
  SET_GROUP_CUSTOMIZATION_PARAMS,
  SET_GROUP_PRIVACY_CUSTOMIZATION_PARAMS,
  SET_GROUP_ROLE_PARAMS,
  SET_USER_BATTLENET_PARAMS,
  SET_USER_NOTIFICATION_PARAMS,
  SET_USER_PATREON_PARAMS,
  SET_USER_PREMIUM_PARAMS,
  SET_USER_PROFILE_PARAMS,
  SET_USER_SOCIAL_PARAMS,
  SHOW_LOADING_SPINNER
} from '../actions/userSettingsActionCreator';

const defaultState = {
  isLoaded: false,
  isLoading: false,
  profile: {},
  social: {},
  notification: {},
  battlenet: {},
  account: {},
  blockList: {},
  characterCustomizations: {},
  characterPrivacy: {},
  groupCustomizations: {},
  groupPrivacy: {},
  groupClientUsage: {},
  groupRoles: {
    pendingRole: {}
  }
};

function sortByCharacterName(a: any, b: any) {
  if (a.character.name === b.character.name) {
    return 0;
  } else if (a.character.name < b.character.name) {
    return -1;
  }
  return 1;
}

export default function userSettings(state: any = _.cloneDeep(defaultState), action: TAction<any>): Partial<any> {
  switch (action.type) {
    case SET_CHARACTER_CUSTOMIZATION_PARAMS: {
      return {
        ...state,
        characterCustomizations: {
          ...(state.characterCustomizations ? state.characterCustomizations : {}),
          ...action.payload
        },
        isLoading: false,
        isLoaded: true
      };
    }
    case SET_CHARACTER_PRIVACY_PARAMS: {
      return {
        ...state,
        characterPrivacy: {
          ...(state.characterPrivacy ? state.characterPrivacy : {}),
          ...action.payload
        },
        isLoading: false,
        isLoaded: true
      };
    }
    case SET_GROUP_CUSTOMIZATION_PARAMS: {
      return {
        ...state,
        groupCustomizations: {
          ...(state.groupCustomizations ? state.groupCustomizations : {}),
          ...action.payload
        },
        isLoading: false,
        isLoaded: true
      };
    }
    case SET_GROUP_PRIVACY_CUSTOMIZATION_PARAMS: {
      return {
        ...state,
        groupPrivacy: {
          ...(state.groupPrivacy ? state.groupPrivacy : {}),
          ...action.payload
        },
        isLoaded: true
      };
    }
    case SET_GROUP_CLIENT_USAGE_DATA: {
      return {
        ...state,
        groupClientUsage: {
          ...(state.groupClientUsage ? state.groupClientUsage : {}),
          ...action.payload
        },
        isLoading: false,
        isLoaded: true
      };
    }
    case SET_GROUP_ROLE_PARAMS: {
      const membersByRank = _.groupBy((action.payload.members || []).sort(sortByCharacterName), 'rank');

      return {
        ...state,
        groupRoles: {
          ...(state.groupRoles ? state.groupRoles : {}),
          ...action.payload,
          rolesByRank: _.groupBy(action.payload.roles || [], 'target_id'),
          membersByRank,
          pendingRole: {}
        },
        isLoading: false,
        isLoaded: true
      };
    }
    case ADD_PENDING_ROLE_PARAMS: {
      return {
        ...state,
        groupRoles: {
          ...state.groupRoles,
          pendingRole: {
            ...state.groupRoles.pendingRole,
            ...action.payload
          }
        }
      };
    }
    case SHOW_LOADING_SPINNER: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case SET_USER_PROFILE_PARAMS: {
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload
        },
        isLoaded: true,
        isLoading: false
      };
    }
    case SET_USER_SOCIAL_PARAMS: {
      return {
        ...state,
        social: {
          ...state.social,
          ...action.payload
        },
        isLoaded: true,
        isLoading: false
      };
    }
    case SET_USER_NOTIFICATION_PARAMS: {
      return {
        ...state,
        notification: {
          ...state.notification,
          ...action.payload
        },
        isLoaded: true,
        isLoading: false
      };
    }
    case SET_USER_BATTLENET_PARAMS: {
      return {
        ...state,
        battlenet: {
          ...state.battlenet,
          ...action.payload
        },
        isLoaded: true,
        isLoading: false
      };
    }
    case SET_USER_PATREON_PARAMS: {
      return {
        ...state,
        patreon: {
          ...state.patreon,
          ...action.payload
        },
        isLoaded: true,
        isLoading: false
      };
    }
    case SET_USER_PREMIUM_PARAMS: {
      return {
        ...state,
        premium: {
          ...state.premium,
          ...action.payload
        },
        isLoaded: true,
        isLoading: false
      };
    }
    case SET_BLOCK_LIST: {
      return {
        ...state,
        blockList: {
          ...state.block,
          list: [...action.payload]
        },
        isLoaded: true,
        isLoading: false
      };
    }
    case RELOAD: {
      return {
        ...state,
        isLoaded: false,
        isLoading: false
      };
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      return _.cloneDeep(defaultState);
    }
    default:
      return state;
  }
}
